import React, { useEffect, useState } from "react";
import TableContext from "../task/TableContext";
import { useEndpointData } from "../../utils/TableUtils";
import RoleService, { RoleGetListRequest } from "../../services/RoleService";

const RoleListEndpoint = async () => {
  const result = await RoleService.getList(new RoleGetListRequest());
  if (result instanceof Error) {
    return result;
  }
  return { list: result.list, result };
};

const RoleTableProvider = (props: React.PropsWithChildren<{}>) => {
  const value = useEndpointData(RoleListEndpoint);
  const [profile, setProfile] = useState("");
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredList, setFilteredList] = useState<any[]>([]);

  useEffect(() => {
    if (!value.response) return;

    const users = value.response.result.list ?? [];

    let filtered = [...users];

    if (profile && profile !== "AllProfiles") {
      filtered = filtered.filter((x) => RoleService.getRole(x) === profile);
    }

    if (searchTerm) {
      filtered = filtered.filter((el) =>
        el.Name.toLowerCase().includes(searchTerm.toLowerCase())
      );
    }

    setFilteredList(filtered);
  }, [value.response, profile, searchTerm]);

  if (value.response) {
    value.response.list = filteredList;
  }

  value.applyFilters = ({
    newProfile,
    searchTerm
  }: {
    newProfile?: string;
    searchTerm?: string;
  }) => {
    if (!value.response) return;

    if (newProfile !== undefined) setProfile(newProfile);
    if (searchTerm !== undefined) setSearchTerm(searchTerm);
  };

  return (
    <TableContext.Provider value={value}>
      {props.children}
    </TableContext.Provider>
  );
};

export default RoleTableProvider;
